import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss";

export const getShippingZones = async () => {
    const url = new URL(process.env.NEXT_PUBLIC_API_URL + '/wc/v3/shipping/zones')
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };
    url.search = new URLSearchParams(params).toString();

    const result =  await fetch(url, {next: {revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE)}})

    return await result.json()
}

export const getShippingZoneMethods = async (id) => {
    const url = new URL(process.env.NEXT_PUBLIC_API_URL + `/wc/v3/shipping/zones/${id}/methods`)
    const params = {
        consumer_key: process.env.NEXT_PUBLIC_WC_CUSTOMER_KEY,
        consumer_secret: process.env.NEXT_PUBLIC_WC_CUSTOMER_SECRET
    };
    url.search = new URLSearchParams(params).toString();

    const result =  await fetch(url, {next: {revalidate: parseInt(process.env.NEXT_PUBLIC_CACHE_REVALIDATE)}})

    return await result.json()
}